import { render, staticRenderFns } from "./Photographers.vue?vue&type=template&id=0d7f8ffa&lang=pug"
import script from "./Photographers.vue?vue&type=script&lang=ts"
export * from "./Photographers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QSelect});
